<template>
    <div id="inner">
        <div id="top-anchor"></div>
        <b-row>
            <b-col>
                <p>
                    Hier vindt u uw reactie(s) op advertenties waar nog op gereageerd kan worden.
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div v-if="!finished" class="text-center">
                    <br/>
                    <h1>Bezig met laden...</h1>
                </div>
                <div v-else-if="adverts.length === 0" class="text-center">
                    <br/>
                    <h1>Geen reacties op actuele advertenties</h1>
                </div>
                <div v-else class="archive" v-for="advert in adverts" :key="advert.advert">
                    <hr/>
                    <house-blurb
                            :advert="advert"
                            :showLetters="false"
                            :withdrawType="'deleteReaction'"
                            :showRemainingTime="true"
                            @withdraw="openReactionDelete"
                    >
                    </house-blurb>
                </div>
            </b-col>
        </b-row>
        <b-modal
                id="delete-reaction-modal"
                title="Wilt u uw reactie verwijderen?"
                size="lg"
                ok-title="Mijn reactie verwijderen"
                ok-variant="danger"
                @ok="confirmReactionDelete"
                cancel-title="Annuleren"
                cancel-variant="info"
        >
            <b-row v-if="Object.keys(deleteAdvert).length > 0" class="archive-block-details">
                <b-col cols="12" lg="6">
                    <h1>
                        {{deleteAdvert.address.street}} {{deleteAdvert.address.number}}
                    </h1>
                    <h2>
                        {{deleteAdvert.address.city}}
                    </h2>
                </b-col>
                <b-col cols="12" lg="6">
                    <b-row>
                        <b-col cols="6">
                            <i class="fad fax fa-pencil"></i>
                            <strong>
                                Gereageerd op
                            </strong>
                        </b-col>
                        <b-col cols="6">
                            {{deleteAdvert.regDate}}
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col cols="6">
                            <i class="fad fax fa-ticket"></i>
                            <strong>
                                Uw positie
                            </strong>
                        </b-col>
                        <b-col cols="5">
                            <i class="fad fax fa-thermometer"></i>
                            &nbsp;&nbsp;&nbsp;
                            {{deleteAdvert.position}}
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <br/>
            <b-row>
                <b-col class="text-muted">
                    Weet u zeker dat u uw reactie wilt verwijderen? Indien u deze reactie verwijderd kunt u tot {{deleteAdvert.periodEnd}} opnieuw reageren op deze woning.
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import {reactionService} from "../../_services/reaction.service";
    import houseBlurb from '@/components/_reaction/houseBlurb'

    export default {
        components: { houseBlurb },
        props: [
            'adverts',
            'finished'
        ],
        data: () => {
            return {
                deleteAdvert: {}
            }
        },
        name: 'onSite',
        mounted() {

        },
        methods: {
            openReactionDelete(advert) {
                this.deleteAdvert = advert
                this.$bvModal.show('delete-reaction-modal')
                let anchor = this.$el.querySelector('#top-anchor')
                anchor.scrollIntoView({ behavior: 'smooth' })
            },
            confirmReactionDelete(e) {
                e.preventDefault()
                reactionService.deleteReaction(this.deleteAdvert.advert).then((data) => {
                    this.$emit('reload')
                    this.$bvModal.hide('delete-reaction-modal')

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item-icon {
        width: 100px;
    }
</style>
